import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Button from '../../Common/Button';
import Icon from "../../Common/Icon";
import { WrapperMemberList } from "./components.js";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";
import ChatUserDeleteOption from "../ChatUserDeleteOption";

class ModalDeletePeopleChat extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      memberList: [],
      membersDeleted: []
    };
  }

  componentDidMount() {
    const { currentUser, memberList } = this.props;
    const members = [...memberList];
    let index = -1;
    memberList.map((item, key) => {
      if (item.user.id === currentUser.id) {
        index = key;
      }
    });
    if (index >= 0) {
      members.splice(index, 1);
    }
    this.setState({
      memberList: [...members],
    });
  }

  onPressClose = (event) => this.props.onClose(event);

  deleteUser = (user) => {
    const { memberList, membersDeleted } = this.state;
    const members = [...memberList];
    membersDeleted.push(user);
    let index = -1;
    members.forEach((item, key) => {
      if (item.user.id === user.id) {
        index = key;
      }
    });
    if (index >= 0) {
      members.splice(index, 1);
    }
    this.props.onSubmit([user]);
    this.setState({
      memberList: [...members],
      membersDeleted: [...membersDeleted]
    });
    if (members.length === 0) {
      this.props.onClose();
    }
  };


  renderItem = (user) => {
    return (
      <ChatUserDeleteOption
        key={user.id}
        user={user}
        onClick={ this.deleteUser }
      />
    )
  };

  render() {

    const { memberList } = this.state;

    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Delete Channel'
        className='Modal_Content'
        overlayClassName='Modal_Overlay Modal_Overlay_Chat'
      >
        <div className='Modal_Content_Container Modal_Content_Container_Delete'>
          <h2>
            Delete people
          </h2>
          <div className='Content'>
            { memberList.length > 0 &&
              <WrapperMemberList>
                { memberList.map(({user}) => this.renderItem(user))}
              </WrapperMemberList>
            }
          </div>
          <div className='Content'>
            <div className='Modal_Content_Actions Center'>
              <Button className='Button_Black Inline Button_Small'
                onClick={ this.onPressClose }
              >
                Cancel
              </Button>
            </div>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalDeletePeopleChat.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalDeletePeopleChat;
